import { FC, useState } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { reportRoute, reportVersionCustomEmailSendRoute } from "app/route/Routes";
import { useRouteParams } from "app/route/route";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { SendCustomReportVersionEmailForm } from "app/component/report-version/SendCustomReportVersionEmailForm";

export const SendCustomReportVersionEmailScreen: FC = () => {
    const { reportId, versionId } = useRouteParams(reportVersionCustomEmailSendRoute);
    const [sent, setSent] = useState(false);

    return sent ? (
        <Navigate to={reportRoute.build({ reportId })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={reportVersionCustomEmailSendRoute} />
                <SendCustomReportVersionEmailForm versionId={versionId} onSend={() => setSent(true)} />
            </Container>
        </NavigationScreen>
    );
};
